import React from 'react';
import '../assets/license.css'
import '../assets/app.css'
import '../App.css'
import DiscountApi from '../api/discount'
import LoadingOverlay from 'react-loading-overlay-ts';
import PlanApi from '../api/plans';

const migrationFile = [
    { value: "1" },
    { value: "2" },
    { value: "3" },
    { value: "4" },
    { value: "5" },
    { value: "6" },
    { value: "7" },
    { value: "8" },
    { value: "9" },
    { value: "10" },
    { value: "11" },
    { value: "12" },
    ]

export default class MigrationSubscriptionCreate extends React.Component {

    constructor(props) {
        super(props)
        this.localhostName = window.location.origin;
        this.state = {
            loading: true,
            showText: true,
            successMessage: false,
            errorMessage: false,
            migrationFile: migrationFile || [],
        };
        // this.init()
    }


    async submitFormSubscriptionCreate(value) {
        const migrationSubscription = await PlanApi.updateRenewalPrice(value)
        if(migrationSubscription === 'success'){
            this.setState({successMessage: true})
        } else {
            this.setState({errorMessage: true})
        }
    }


    render() {
        const { showText, loading, successMessage, errorMessage, migrationFile } = this.state
        return (
            <>
            {migrationFile.map((item1, index) => (
                <input key={item1.value || index} className="fusion-button button-flat fusion-button-square button-large button-blue button-1 input-country" style={{ height: '30px', paddingTop: 0, paddingBottom: 0, margin: '20px' }} name="text" placeholder="Submit for Subscription Create" value={item1.value} size="40" type="button" onClick={() => this.submitFormSubscriptionCreate(item1.value)}
                />
            ))}
                {successMessage ?
                    <div className="migrationSubscription" style={{color: 'green', margin: '20px', fontSize: '16px'}}>
                        Migration Subscription created Successfully
                    </div>
                : null}
                {errorMessage ?
                    <div className="migrationSubscription" style={{color: 'red', margin: '20px', fontSize: '16px'}}>
                        Something went wrong, while migration process
                    </div>
                : null}
            </>
        )
    }

    
}
